<!-- ========================================================================================
      Author: Mahdavi
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <div>
    <div class="vx-row">

      <!-- CARD 2: مشتریان جدید -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-2/4 xl:w-2/4 mb-base">
        <statistics-card-line
          icon="UsersIcon"
          :statistic="GetInfo.merchantCount"
          statisticTitle="تعداد پذیرنده ها"
          :chartData="ordersRecevied.series"
          :chartOptions="{tooltip: {
          enabled: false}}"
          type="area"
        ></statistics-card-line>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-2/4 xl:w-2/4 mb-base">
        <statistics-card-line
          icon="DollarSignIcon"
          :statistic="GetInfo.transactionCount"
          statisticTitle="تعداد تراکنش ها"
          :chartData="ordersRecevied.series"
          color="warning"
          type="area"
        ></statistics-card-line>
      </div>
    </div>



    <vs-collapse class="p-0 m-0 bg-white" type="margin">
      <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down">
        <div slot="header">
          <feather-icon
            icon="FilterIcon"
            svgClasses="text-primary"
          ></feather-icon
          >فیلترها
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full ml-5">
            <div class="vx-row mb-2">
              <div class="vx-col sm:w-2/12 flex-inline">
                <span>کد بازاریاب خرد:</span>
              </div>
              <div class="vx-col sm:w-8/12 flex-inline">
                <vs-input v-model="filter" class="w-full" />
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col">
            <vs-button @click="clear" class="mx-3" color="primary" type="border"
              >پاک کردن</vs-button
            >
          </div>
          <div class="vx-col">
            <vs-button
              @click="
                pageNo = 1;
                fillTable(false);
              "
              class="mx-3"
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-search"
              >جستجو</vs-button
            >
          </div>
        </div>
      </vs-collapse-item>
    </vs-collapse>
    <vx-card class="mb-2">
      <div
        class="vx-row mb-2"
        v-if="$route.query.userId || $route.query.title">
        <h3 class="ml-3">پذیرنده های بازاریاب "{{ $route.query.title }}"</h3>
        <div class="vx-col w-full">
          <vs-button
            class="mr-3 mb-2"
            @click="$router.go(-1)"
            type="flat"
            icon-pack="feather"
            icon="icon-chevron-right"
            >بازگشت</vs-button
          >
        </div>
      </div>

      <vs-table
        id="tbl2"
        ref="tbl2"
        :data="merchants"
        class="table-dark-inverted"
        @selected="selected"
      >
        <template slot="header">
          <div class="vx-row mb-2 w-full">
            <div class="vx-col sm:w-2/3 flex-inline">
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <div
                        class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                      >
                        <span class="mr-2">
                          {{ (pageNo - 1) * pageSize + 1 }}
                          -
                          {{
                            pageNo * pageSize > totalCount
                              ? totalCount
                              : pageNo * pageSize
                          }}
                          از {{ totalCount }}
                        </span>
                        <feather-icon
                          icon="ChevronDownIcon"
                          svgClasses="h-4 w-4"
                        />
                      </div>
                      <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="SetPageSize(5)">
                          <span>5</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(10)">
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(20)">
                          <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(50)">
                          <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(100)">
                          <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(150)">
                          <span>150</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template slot="thead">
          <vs-th>نام</vs-th>
          <vs-th>نام فروشگاه</vs-th>
          <vs-th>شماره موبایل</vs-th>
          <vs-th>تاریخ ثبت نام</vs-th>
          <vs-th v-if="$acl.check('isAdmin')"> جمع مبلغ</vs-th>
          <vs-th>تعداد تراکنش</vs-th>
          <vs-th> کد بازاریاب خرد</vs-th>

          <!-- <vs-th>نام</vs-th>
          <vs-th>نام خانوادگی</vs-th>-->
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
            
              <span>{{ tr.firstName +" "+ tr.lastName}}</span>
              
            </vs-td>
            <vs-td>
            
              <span>{{ tr.shopName}}</span>
              
            </vs-td>
            <vs-td>
            
              <span>{{tr.moblie}}</span>
              
            </vs-td>
            <vs-td>
              <span>
                {{
                 $moment(tr.registerDate).format("HH:mm:ss - jYYYY/jM/jD")
                }}</span
              >
            </vs-td>
            <vs-td v-if="$acl.check('isAdmin')">
              <span> {{ tr.totalAmount }}</span>
            </vs-td>
            <vs-td>
              <span> {{ tr.transactionCount }}</span>
            </vs-td>
            <vs-td>
              <span> {{ tr.subPromoterCode }}</span>
            </vs-td>

            <vs-td class="pl-0 pr-0">
              <vs-chip
                v-for="item in tr.roles"
                :key="item.roleId"
                :color="Colors[item.roleId % 5]"
                class="product-order-status"
                >{{ item.roleName }}</vs-chip
              >
            </vs-td>
            <!-- <vs-td>
              <span>{{tr.firstName}}</span>
            </vs-td>
            <vs-td>
              <span>{{tr.lastName}}</span>
            </vs-td>-->
            <!-- <vs-td>
              <a @click="showBills(tr.id,tr.userName)">قبضهای‌دریافتی</a>
            </vs-td>
            <vs-td>
              <a @click="showTransaction(tr.id,tr.userName)">تراکنشها</a>
            </vs-td>
            <vs-td>
              <vs-dropdown>
                <a class="flex items-center" href.prevent>
                  عملیات
                  <i class="material-icons">expand_more</i>
                </a>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="manageRoles(tr.id,tr.userName)">مدیریت نقشها</vs-dropdown-item>
                  <vs-dropdown-item @click="manageDepartments(tr.id,tr.userName)">مدیریت دپارتمانها</vs-dropdown-item>
                  <vs-dropdown-item @click="managePermissions(tr.id,tr.userName)">مدیریت مجوزها</vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td> -->
          </vs-tr>
        </template>
      </vs-table>

      <vs-pagination
        :total="pagesCount"
        v-model="pageNo"
        @input="
          (val) => {
            fillTable(val);
          }
        "
      />
    </vx-card>
    <user-roles ref="UserRoles1" @success="fillTable()"></user-roles>
  </div>
</template>
<style>
.nav-transacttions > .vs-popup {
  width: 100%;
}
</style>
<script>
import vSelect from "vue-select";
import { MerchantStatus, Colors } from "@/enums.js";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import Vue from "vue";
import UserRoles from "../user/UserRoles";
export default {
  props: {
    transactions: {},
  },
  components: {
    "v-select": vSelect,
    UserRoles,
    StatisticsCardLine,
  },
  data() {
    return {
      merchants: [],
      roles: [],
      permissions: [],
      Colors,
      totalCount: 1,
      pageSize: 10,
      pagesCount: 1,
      pageNo: 1,
      userName: "",
      filter: "",
      role: "",
      permission: "",
      GetInfo: [],
      ordersRecevied: {},
    };
  },
  computed: {},
  methods: {
    fillTable() {
      let loading = this.$vs.loading();
      //this.$vs.loading()

      let payload = {
        params: {
          MaxResultCount: this.pageSize,
          SkipCount: this.pageSize * (this.pageNo - 1),
          Role: this.role == null ? null : this.role.value,
          Permission: this.permission == null ? null : this.permission.value,
          SubPromoterFilter: this.filter,
        },
      };
      if (this.$route.query.userId) payload.params.code = this.$route.query.userId;
      const url = this.$route.query.userId ?"/api/services/app/Promoters/GetMerchantsByCode":"/api/services/app/Promoters/GetMerchantsOfCurrentUser";
      
      this.$http
        .get(url, payload)
        .then((response) => {
          console.log(response);
          this.merchants = response.data.result.items;
          this.totalCount = response.data.result.totalCount;
          this.pagesCount = Math.ceil(this.totalCount / this.pageSize);
          
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    clear() {
      this.role = "";
      this.permission = "";
      this.userName = "";
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.fillTable();
    },
    manageRoles(userId, username) {
      this.$refs.UserRoles1.show(userId, username);
    },
    manageDepartments(userId, username) {},
    managePermissions(userId, username) {},
    showBills(userId, username) {
      this.$router.push({
        name: "ConsumerBills",
        query: {
          title: username,
          userId: userId,
        },
      });
    },
    selected(tr) {
      //this.showTransaction(tr.transaction.id);
    },
    getRoles() {
      let loading = this.$vs.loading();
      this.$http
        .get("/api/services/app/Role/GetRoles")
        .then((response) => {
          this.roles = response.data.result.items.map((x) => {
            return { value: x.id, label: x.displayName };
          });
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    showTransaction(userId, username) {
      this.$router.push({
        name: "AllTransactions",
        query: {
          username: username,
          userId: userId,
        },
      });
    },
  },
  mounted() {
  },
  created(){
    this.$http
      .get("/api/services/app/Promoters/GetInfoByDays")
      .then(response => {
        this.GetInfo = response.data;
      })
      .catch(error => {
        console.log(error);
      });
      
    // Orders - Statistics
    this.$http
      .get("/api/card/card-statistics/orders")
      .then(response => {
        this.ordersRecevied = response.data;
      })
      .catch(error => {
        console.log(error);
      });
  },
};
</script>
